// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redeem-action[data-v-e2a4628e]{cursor:pointer;display:flex;align-items:center;gap:8px;margin-top:8px}.redeem-icon[data-v-e2a4628e]{width:20px;height:20px}.redeem-text[data-v-e2a4628e]{font-size:15.2px;color:#159c34;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
